import { render, staticRenderFns } from "./LikeTweet.vue?vue&type=template&id=378f65fd&scoped=true"
import script from "./LikeTweet.vue?vue&type=script&lang=js"
export * from "./LikeTweet.vue?vue&type=script&lang=js"
import style0 from "./LikeTweet.vue?vue&type=style&index=0&id=378f65fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378f65fd",
  null
  
)

export default component.exports